export const getMetaValue = name => document.querySelector(`meta[name="${name}"]`).content;



// WEBPACK FOOTER //
// ./app/javascript/common/utils/meta.js